import {Injectable, signal} from '@angular/core';
import { fetchAuthSession, fetchUserAttributes, signOut } from '@aws-amplify/auth';


type UserInfo = {
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
}

@Injectable({
  providedIn: 'root',
})


export class User {

  admin = signal<boolean>(false);
  userInfo = signal<UserInfo>({});
  private initialized = false;

  constructor() {
    // Don't call async methods in constructor
    // They will be called via init() method
  }

  async init() {
    if (this.initialized) {
      return;
    }
    try {
      await Promise.all([
        this.isAdmin(),
        this.getUserInfo()
      ]);
      this.initialized = true;
    } catch (error) {
      console.error('[User] Initialization failed:', error);
      throw error;
    }
  }

  async isAdmin () {
    const session = await fetchAuthSession();

    const roleAttr = session.tokens?.idToken?.payload['cognito:groups'] as string[] | undefined;
    const isAdmin = roleAttr?.includes('ADMIN') || roleAttr?.includes('SUPERADMIN') || false;
    this.admin.set(isAdmin);
  }


  async getUserInfo() {
    const attributes = await fetchUserAttributes();
    const userInfo: UserInfo = {
      name: attributes.name,
      first_name: attributes.given_name,
      last_name: attributes.family_name,
      email: attributes.email,
      phone_number: attributes.phone_number
    };

    this.userInfo.set(userInfo);
  }

  async signOut() {
    try {
      await signOut();

      this.userInfo.set({});
      this.admin.set(false);
      this.initialized = false;

      localStorage.removeItem('userInfo');
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  }

  resetState() {
    this.userInfo.set({});
    this.admin.set(false);
    this.initialized = false;
  }
}
